import { ECompareFlightTooltipTypes } from '../../actions/compareFlightTooltip';
import { ICompareFlightTooltipState, TReduxActions } from '../../types/redux';

const initialState: ICompareFlightTooltipState = {
  isCompareFlightTooltipShow: false,
  isCompareFlightModalOpen: false,
};

export function compareFlightTooltipReducer(
  state: ICompareFlightTooltipState = initialState,
  action: TReduxActions,
): ICompareFlightTooltipState {
  switch (action.type) {
    case ECompareFlightTooltipTypes.SetCompareFlightModalOpen:
      return {
        ...state,
        isCompareFlightModalOpen: action.payload,
      };
    default:
      return state;
  }
}
